import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Add, PrintOutlined, PrintSharp, Search } from "@material-ui/icons";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import FilterListIcon from "@material-ui/icons/FilterList";
import SyncIcon from "@material-ui/icons/Sync";
import CommonButton from "app/common/Component/Button/CommonButton";
import {
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleHisReadOnly,
  isRoleTechician,
  isSalesConsultant,
} from "app/common/LocalFunction";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { pagingDrugOrder } from "app/services/DrugService";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";

const SearchRegisterProduct = ({ selectedProductOrders }) => {
  console.log("🚀 ~ SearchRegisterProduct ~ selectedProductOrders:", selectedProductOrders)
  let [isOpenFillter, setOpenFillter] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    handleOpenAddProductAdvicePopup,
    handleOpenCreateOrEditCardPopup,
    searchRegisterProduct,
    handleSetPrintContent,
    pageRegisterProduct,
    handleOpenRequestStoreExportProductsPopup,
  } = useStore().patientManagementStore.registerProductStore;
  const {
    initialPatient,
  } = useStore().patientManagementStore.patientGeneralStore;
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  const { values, setFieldValue } = useFormikContext();

  async function handlePrintAllItems() {
    try {
      const payload = {
        ...searchRegisterProduct,
        pageIndex: 1,
        pageSize: 9999999,
        patientId,
      };

      if (!patientId) {
        throw new Error("Chưa xác định được bệnh nhân");
      }

      const { data } = await pagingDrugOrder(payload);

      handleSetPrintContent(data?.content || []);
    } catch (error) {
      toast.error("Có lỗi xảy ra khi in tất cả dữ liệu, vui lòng thử lại sau");
      console.error(error);
    }
  }

  async function handlePrintChosenItems(chosenCards) {
    try {
      const chosenItems = [...chosenCards];

      handleSetPrintContent(chosenItems || []);
    } catch (error) {
      toast.error("Có lỗi xảy ra khi in tất cả dữ liệu, vui lòng thử lại sau");
      console.error(error);
    }
  }
  const department = useDefaultDepartment();
  console.log("departmentdepartment", department);

  let isAdminPermission = isAdmin();
  let isRoleCashierPermission = isRoleCashier();
  let isRoleBranchManagerPermission = isRoleBranchManager();
  let isSalesConsultantPermission = isSalesConsultant();
  let isDoctorPermission = isDoctor();
  const isReadonly = isRoleHisReadOnly();
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAccountant = isRoleHisAccountant();
  const hasAddPermission =
    isRoleCt || isAdminPermission || isRoleBranchManagerPermission || isRoleCashierPermission || isAccountant;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const isInDetailPage =
    location.pathname === "/treatment-management/treatment-patient-info-detail";
  const defaultDepartment = useDefaultDepartment();
  return (
    <>
      <Grid item xs={12} style={{ padding: "8px 0" }}>
        <div
          className="flex"
          style={{
            justifyContent: "space-between",
            flexWrap: "wrap",
            padding: "10px",
          }}
        >
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div className="flex items-center" style={{ color: "#4276a4" }}>
                <p className="cards-header flex align-center item-form-header-custom">
                  <span className="flex items-center pointer">Sản phẩm</span>
                  <span
                    style={{ cursor: "pointer" }}
                    className="flex items-center"
                    onClick={() => setOpenFillter(!isOpenFillter)}
                  >
                    <FilterListIcon color="red" />
                  </span>
                </p>
              </div>
              <div style={{ float: "right" }}>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginTop: "0px",
                  }}
                >
                  {!isMobile && selectedProductOrders?.length > 0 && (
                    <Tooltip
                      placement="top"
                      arrow
                      title="Tạo phiếu in các hạng mục đã chọn"
                    >
                      <CommonButton
                        onClick={async (e) => {
                          handlePrintChosenItems(selectedProductOrders);
                        }}
                        style={{
                          backgroundColor: "#f16321",
                          color: "white",
                          marginRight: "4px",
                        }}
                      >
                        <PrintOutlined />
                        {!isMobile && " In tùy chọn"}
                      </CommonButton>
                    </Tooltip>
                  )}
                  {hasAddPermission && !isInDetailPage && (
                    <>
                      <Tooltip
                        placement="top"
                        arrow
                        title="Tạo yêu cầu xuất kho"
                      >
                        <CommonButton
                          onClick={() => {
                            if (
                              !selectedProductOrders ||
                              selectedProductOrders.length === 0
                            ) {
                              toast.warning(
                                "Vui lòng chọn sản phẩm để xuất kho!"
                              );
                              return;
                            }

                            const now = new Date();

                            // So sánh thời gian hiện tại và ngày hết hạn
                            const isExpired = (expiryRaw) => {
                              if (!expiryRaw) return false;

                              const expiry =
                                typeof expiryRaw === "number"
                                  ? new Date(expiryRaw)
                                  : new Date(expiryRaw);

                              return expiry < now; // nếu nhỏ hơn hiện tại => hết hạn
                            };

                            // Sản phẩm còn hạn là chưa hết hạn (hoặc không có ngày)
                            const validProducts = selectedProductOrders.filter(
                              (item) => !isExpired(item.expiryDate)
                            );

                            const expiredProducts =
                              selectedProductOrders.filter((item) =>
                                isExpired(item.expiryDate)
                              );

                            if (
                              selectedProductOrders.length === 1 &&
                              expiredProducts.length > 0
                            ) {
                              toast.warning(
                                "Sản phẩm đã hết hạn, không thể xuất kho!"
                              );
                              return;
                            }

                            if (validProducts.length === 0) {
                              toast.warning(
                                "Tất cả sản phẩm đã hết hạn, không thể xuất kho!"
                              );
                              return;
                            }

                            if (expiredProducts.length > 0) {
                              const expiredNames = expiredProducts
                                .map(
                                  (p) =>
                                    p.productName || p.name || "Không rõ tên"
                                )
                                .join(", ");
                              toast.warning(
                                `${expiredProducts.length} sản phẩm đã hết hạn (ví dụ: ${expiredNames}) và sẽ không được xuất kho.`
                              );
                            }

                            handleOpenRequestStoreExportProductsPopup({
                              department,
                              selectedProductOrders: validProducts,
                              patientId,
                            });
                          }}
                          style={{
                            backgroundColor: "#f16321",
                            color: "white",
                            marginRight: "4px",
                          }}
                        >
                          Xuất kho
                        </CommonButton>
                      </Tooltip>
                    </>
                  )}

                  {!isMobile ||
                    (!isReadonly &&
                      pageRegisterProduct?.content?.length > 0 && (
                        <Tooltip
                          placement="top"
                          arrow
                          title="Tạo phiếu in tất cả các hạng mục"
                        >
                          <CommonButton
                            onClick={async (e) => {
                              handlePrintAllItems();
                            }}
                            style={{
                              backgroundColor: "#f16321",
                              color: "white",
                              marginRight: "4px",
                            }}
                          >
                            <PrintSharp />
                            {!isMobile && "In tất cả"}
                          </CommonButton>
                        </Tooltip>
                      ))}

                  {(hasAddPermission) && (
                    <CommonButton
                      className="btn-add "
                      onClick={async (e) =>
                        setAnchorEl(anchorEl ? null : e.target)
                      }
                      style={{ position: "relative", height: "100%" }}
                    >
                      <Add />
                      {!isMobile && " Sản phẩm"}
                    </CommonButton>
                  )}
                  {anchorEl && hasAddPermission && (
                    <div
                      className="popover-list"
                      style={{
                        right: 0,
                        left: "auto",
                        position: "absolute",
                        minWidth: "160px",
                      }}
                    >
                      <div
                        className="popover-item popover-item-custom"
                        style={{ color: "#4276a4" }}
                        onClick={() => {
                          handleOpenCreateOrEditCardPopup(
                            null,
                            initialPatient?.patientInfo,
                            defaultDepartment
                          );
                          setAnchorEl(null);
                        }}
                      >
                        <AddCircleOutlineIcon
                          fontSize="small"
                          className="icon"
                        />
                        Thêm
                      </div>
                      <div
                        className="popover-item"
                        style={{ color: "#4276a4" }}
                        onClick={() => {
                          handleOpenAddProductAdvicePopup({
                            orderDate: values?.orderDate,
                            patientId,
                          });
                          setAnchorEl(null);
                        }}
                      >
                        <SyncIcon
                          fontSize="small"
                          color="#007b8f"
                          className="icon"
                        />
                        Lấy từ tư vấn
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>
      {!isOpenFillter && (
        <>
          <style>
            {`
                @keyframes slideDownFade {
                  0% {
                    opacity: 0;
                    transform: translateY(-10px);
                  }
                  100% {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
              `}
          </style>
          <div
            style={{
              animation: "slideDownFade 0.3s ease forwards",
              zIndex: 10,
              position: "relative",
            }}
          >
            <Grid container spacing={1} className="cards-body">
              <Grid item xs={12} sm={6} md={3}>
                <GlobitsTextField
                  label="Tìm kiếm"
                  name="keyword"
                  placeholder={"Nhập tên/Mã dịch vụ"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsMultiDatePicker
                  label="Ngày đăng ký từ ngày - đến ngày"
                  name="fromDate"
                  range
                  rangeHover
                  fromField="fromDate"
                  toField="toDate"
                // format={"DD/MM/YYYY"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsDateTimePicker
                  name={"orderDate"}
                  label="Ngày tư vấn"
                  maxDateMessage="Ngày tư vấn phải trước ngày hiện tại"
                  maxDate={new Date()}
                // isDateTimePicker
                />
              </Grid>
              <Grid item xs={12} sm={6} md={5} className="flex flex-end gap-2">
                <Button className="btn-primary" type="submit">
                  <Search />
                  Tìm kiếm
                </Button>
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

export default memo(observer(SearchRegisterProduct));
